import { useContext } from "react";
import { AudioPlayerContext } from "../contexts";

const useAudioPlayer = () => {
  return useContext(AudioPlayerContext);
};

export default useAudioPlayer;
